import { AppVersionFormValues } from './types';


export function isForceUpdate(versionCode?: string | null, minVersion?: string | null): boolean {
  const v = versionCode?.trim() ?? '';
  const m = minVersion?.trim() ?? '';
  return Boolean(v && m && v === m);
}


export function toApiPayload(values: AppVersionFormValues) {
  const { forceUpdate, ...rest } = values;
  const versionCode = values.versionCode?.trim() ?? '';
  return {
    ...rest,
    versionCode,
  };
}
